import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import EnergyHubList from './energy-hub-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Energy Hubs">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Energy Hubs</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <EnergyHubList />
    </Panel>
  );
};

export default Page;
